import ConcessionModal from "./ConcessionModal.container";

export default ConcessionModal;